import type { BlurTint, BlurViewProps } from 'expo-blur';
import { memo } from 'react';
import { View } from 'react-native';

const getBackgroundColor = (tint: BlurTint) => {
  switch (tint) {
    case 'light':
      return 'rgba(255,255,255,0.5)';
    case 'dark':
      return 'rgba(0,0,0,0.5)';
    default:
      // will just blur without any tinting.
      return 'transparent';
  }
};

export const BlurView = memo(
  ({ tint = 'default', intensity = 60, style, ...props }: BlurViewProps) => {
    return (
      <View
        style={[
          {
            backdropFilter: `blur(${intensity}px)`,
            backgroundColor: getBackgroundColor(tint),
          } as any,
          style,
        ]}
        {...props}
      />
    );
  },
);
